import Cookies from 'js-cookie'
import { handleSessionExpired } from '@/lib/authToken'

const API_BASE = (import.meta.env?.VITE_API_URL as string) || ''

function buildUrl(path: string): string {
  if (API_BASE) return `${API_BASE.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
  return path.startsWith('/') ? path : `/${path}`
}

export async function getOutlookWorkspaceOAuthUrl(workspaceId: string): Promise<string> {
  const token = Cookies.get('token')
  const res = await fetch(buildUrl(`/api/workspaces/${workspaceId}/outlook-workspace/oauth/start`), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (res.status === 401 && token) { handleSessionExpired(); throw new Error('Session expired') }
  if (!res.ok) throw new Error('Failed to start Outlook Workspace authorization')
  const data = await res.json() as { url: string }
  return data.url
}

export async function disconnectOutlookWorkspace(workspaceId: string): Promise<void> {
  const token = Cookies.get('token')
  const res = await fetch(buildUrl(`/api/workspaces/${workspaceId}/outlook-workspace`), {
    method: 'DELETE',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (res.status === 401 && token) { handleSessionExpired(); throw new Error('Session expired') }
  if (!res.ok) throw new Error('Failed to disconnect Outlook Workspace')
}
